/*
 * @Author: lvjun
 * @Date：2021-27
 * @Description: 定义项目枚举值
 */
export const DICT = {
  yesNoStatus: [
    { value: 1, label: '是', name: '是' },
    { value: 2, label:'否', name: '否' }
  ],
  //公告类型
  AnnouncementType:[
    { value: 10000, label: '公告', name: '公告' },
    { value: 20000, label:'提醒', name: '提醒' }
  ],
   //数据来源
   customerSource:[
    { value: 1, label: '驿站web', name: '驿站web' },
    { value: 2, label:'驿站APP', name: '驿站APP' }
  ],
   //客户等级
  customerLevel:[
    { value: 1, label: '优质', name: '优质' },
    { value: 2, label:'良好', name: '良好' },
    { value: 3, label: '普通', name: '普通' },
    { value: 4, label:'疑难', name: '疑难' }
  ],
  // 短信发送状态
  sendStatus: [
    { value: 0, label: '发送中', name: '发送中' },
    { value: 1, label:'发送成功', name: '发送成功' },
    { value: 2, label: '发送失败', name: '发送失败' }
  ],
  //通知状态
  platformNotifyStatus:[
    { value: 0, label: '未通知', name: '未通知' },
    { value: 10, label:'通知中', name: '通知中' },
    { value: 20, label: '通知失败', name: '通知失败' },
    { value: 30, label: '通知成功', name: '通知成功' }
  ],
  //取件状态
  waybillStatus:[
    { value: 100, label: '待自提', name: '待自提' },
    { value: 200, label:'待送货上门', name: '待送货上门' },
    { value: 300, label: '待退回', name: '待退回' },
    { value: 301, label: '已退回', name: '已退回' },
    { value: 999, label: '签收出库', name: '签收出库' }, 
  ],
  //包裹类型
  parcelType:[
    { value: 1, label: '普通件', name: '普通件' },
    { value: 2, label:'生鲜件', name: '生鲜件' },
  ],
  //账号状态
  staffStatus:[
    { value: 4, label: '营业', name: '营业' },
    { value: 5, label: '下线', name: '下线' },
  ],
  // 干线状态
  shipmentState: [
    { value: 0, label: '待调度', name: '待调度' },
    { value: 1, label: '已调度', name: '已调度' },
    { value: 2, label: '待执行', name: '待执行' },
    { value: 3, label: '在途', name: '在途' },
    { value: 4, label: '已完成', name: '已完成' },
    { value: 5, label: '已作废', name: '已作废' }
  ]
}
